import { EmeraldError } from 'src/common/api/emerald-error';
import { CartMetadata } from 'src/common/interfaces/dtos/ICartMetadata';
import { DataAddType } from '../../common/enumerations/data-add-type';
import { IRetailTransactionSearchCriteria } from '../../common/interfaces/dtos/IRetailTransactionSearchCriteria';
import { IItemInputData } from '../../common/interfaces/IItemInputData';
import { getDataInformation } from '../../home-page/business-logic/get-data-infomation';
import { getRecallOrder } from './get-recall-order';
import { recallOrderLookup } from './recall-order-lookup';

export const recallOrderByCodeEntered = async (
  input: IItemInputData,
  isPhoneNumber: boolean = false,
): Promise<void> => {
  if (input.itemId) {
    if (isPhoneNumber) {
      return searchOrdersByCode(input.itemId, true);
    } else {
      return getDataInformation(input).then(dataInfo => {
        if (dataInfo.type === DataAddType.Customer) {
          return searchOrdersByCode(input.itemId ?? '');
        } else {
          return getRecallOrder(input.itemId ?? '');
        }
      });
    }
  } else {
    throw new EmeraldError('InvalidInput');
  }
};

const searchOrdersByCode = async (id: string, isPhoneNumber: boolean = false): Promise<void> => {
  const searchCriteria: IRetailTransactionSearchCriteria = isPhoneNumber
    ? { PhoneNumber: id }
    : { CustomerId: id };
  return recallOrderLookup(searchCriteria).then(
    async (recallOrders: CartMetadata[]): Promise<void> => {
      if (recallOrders.length === 1) {
        return getRecallOrder(recallOrders[0].orderId);
      }
    },
  );
};
